import { forwardRef, type SelectHTMLAttributes } from "react";
import { FiChevronDown } from "react-icons/fi";
import { twMerge } from "tailwind-merge";

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, invalid = false, children, ...props }, ref) => (
    <span className="relative block">
      <select
        aria-invalid={invalid || undefined}
        className={twMerge(
          "min-h-11 w-full appearance-none rounded-lg border border-line bg-surface py-2 pl-3.5 pr-10 text-sm text-ink shadow-sm transition-[border-color,box-shadow] hover:border-accent/60 focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/20 disabled:cursor-not-allowed disabled:bg-line/30 disabled:opacity-70",
          invalid && "border-danger",
          className
        )}
        ref={ref}
        {...props}
      >
        {children}
      </select>
      <FiChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute right-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted"
      />
    </span>
  )
);
Select.displayName = "Select";
